import confetti from 'canvas-confetti'

export default (confettiType, options) => {
  const getOrigin = event => {
    const rect = event.currentTarget.getBoundingClientRect()
    const x = rect.left + rect.width / 2
    const y = rect.top + rect.height / 2
    return {
      x: x / window.innerWidth,
      y: y / window.innerHeight,
    }
  }

  const defaultConfetti = async event => {
    try {
      await confetti({
        ...options,
        origin: getOrigin(event),
      })
    } catch (error) {
      console.error('Confetti button error:', error)
    }
  }

  const largeConfetti = async () => {
    const scalar = 2
    const triangle = confetti.shapeFromPath({
      path: 'M0 10 L5 0 L10 10z',
    })
    const square = confetti.shapeFromPath({
      path: 'M0 0 L10 0 L10 10 L0 10 Z',
    })
    const coin = confetti.shapeFromPath({
      path: 'M5 0 A5 5 0 1 0 5 10 A5 5 0 1 0 5 0 Z',
    })
    const tree = confetti.shapeFromPath({
      path: 'M5 0 L10 10 L0 10 Z',
    })
    const defaults = {
      spread: 360,
      ticks: 60,
      gravity: 0,
      decay: 0.97,
      startVelocity: 20,
      shapes: [triangle, square, coin, tree],
      scalar,
    }
    const shoot = () => {
      confetti({
        ...defaults,
        ...options,
        particleCount: 30,
      })
      confetti({
        ...defaults,
        ...options,
        particleCount: 5,
      })
      confetti({
        ...defaults,
        ...options,
        particleCount: 15,
        scalar: (options?.scalar ?? scalar) / 2,
        shapes: ['circle'],
      })
    }
    setTimeout(shoot, 0)
    setTimeout(shoot, 100)
    setTimeout(shoot, 200)
  }

  switch (confettiType) {
    case 'default':
      return defaultConfetti
    case 'large':
      return largeConfetti
    default:
      return defaultConfetti
  }
}
